module.exports = __webpack_public_path__ + "static/media/uoa-8.03e6a22d.jpg";